import { loadMore } from './functions';

loadMore( 'main.site-main .woocommerce-pagination ul.page-numbers a.next', 'main.site-main ul.products', 'main.site-main ul.products > li' );

loadMore( '.nav-links .nav-previous > a', '#main-content .posts-list', '#main-content .posts-list > .single-result' );

loadMore( '.page-template-page_filter_results .page-navigation a', '.page-template-page_filter_results  main.site-main ul.products', '.page-template-page_filter_results  main.site-main ul.products > li' );
